import type { FaireProductEntity } from "../../entity_types/product";

export const p_5mcrgjwe7w: FaireProductEntity = {
  token: "p_5mcrgjwe7w",
  type: "product",
  name: "18K Gold Plated Waterproof Stainless Steel Ring - 7925",
  brandToken: "b_4zc36e4kj9",
  brandName: "Mia Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/a915a066d2f062f3ed46acf6558ac94a68a18fb22df5a7fe0becb37118a55b41.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4c64852fa263880e8ec49b04e896551dc41ff16ef4c1a04980d50e7461a61284.jpeg",
    "https://cdn.faire.com/fastly/d550ff9b202f92d952cae80c84d7981afe507e9cdfdf5611cd238d8eafc0b86a.jpeg",
    "https://cdn.faire.com/fastly/cf0d2e08a8d85db19d9616af09bd5f52dc45b5340f196c53f3d3731f1572ef9e.jpeg",
    "https://cdn.faire.com/fastly/aae404dc62e73fd84d38042c9886e59a5f36b441e739fcd90d80940b460a05b3.jpeg",
  ],
  priceDollars: 8.24,
  description:
    "18K gold plated stainless steel ring.\n\n\n\nThis item is hypoallergenic, waterproof and tarnish-resistant.\n\n*To prolong the shine and finish of the plating, contact with chemicals such as lotions, perfumes, and cleaning products should be avoided.*\n\n\n\nTwo Tone Adjustable Ring | Duo Tone Statement Ring | Minimal Ring | Real Gold Dipped Ring | Gold Plated Ring | Waterproof & Sweatproof Ring | Simple Gold Ring\n",
  tags: [],
  msrpDollars: 32.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:09.466Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
